(function($) {
  
    $(document).ready(function() {
        
    });
  
})(jQuery);

function initMemberFormPage(){
    var $ = jQuery;
    $('.is-wp-upload .file-picker-button, .is-wp-upload .image-picker-button, .button-group .image-picker-button, .is-wp-repeater .tr-repeater-button-add .button, .is-wp-repeater .button-group .file-picker-button').addClass('m-button')
    $('.is-wp-upload .file-picker-clear, .is-wp-upload .image-picker-clear, .is-wp-repeater .button-group .file-picker-clear').addClass('m-button is-border')
    $('.file-picker-placeholder a, .image-picker-placeholder a').each(function() {
        $(this).text($(this).attr('href').split('/').pop());
    })
    $('.typerocket-elements-fields-select.is-single select, .rqd_members-typerocket-fields-other.is-single select').multipleSelect({
        single:true,
        placeholder: objectL10n.placeholder,
        formatNoMatchesFound : function() {return objectL10n.noMatchesFound},
        filter: true,
        selectAll: false,
        formatCountSelected: function(count, total) {
            return count+' '+objectL10n.choix;
        },
        onFocus: function(view){
            $(this).parent().removeClass('is-open');
        },
        onBlur: function(view){
            $(this).parent().addClass('is-open');
        }
    }).trigger('onBlur');

    $('.typerocket-elements-fields-select.is-multiple select, .rqd_members-typerocket-fields-other.is-multiple select').multipleSelect({
        placeholder: objectL10n.multiplePlaceholder,
        formatNoMatchesFound : function() {return objectL10n.noMatchesFound},
        filter: true,
        selectAll: false,
        formatCountSelected: function(count, total) {
            return count+' '+objectL10n.choix;
        },
        onClick: function(view) {
            $('.typerocket-elements-fields-select.is-multiple select').each(function(){
                if($(this).multipleSelect('getSelects').length){
                    $(this).parent().find('.ms-parent .ms-choice div').html('<div class="count">'+$(this).multipleSelect('getSelects').length+'</div>')
                }else{
                    $(this).parent().find('.ms-parent .ms-choice div').html('')
                }
            })
        },
        onFocus: function(view){
            $(this).parent().removeClass('is-open');
        },
        onBlur: function(view){
            $(this).parent().addClass('is-open');
        }
    });
    jQuery('.typerocket-elements-fields-select.is-relation select').each(function(){
        $(this).attr('id','select-nb-'+Math.floor(Math.random() * 999999999999))
    })
    jQuery('.typerocket-elements-fields-select.is-relation select').multiSelect()
    jQuery('.typerocket-elements-fields-select.is-relation-w-search select').multiSelect({
        selectableHeader: "<input type='text' class='search-input' autocomplete='off' placeholder='"+objectL10n.search+"'>",
        selectionHeader: "<input type='text' class='search-input' autocomplete='off' placeholder='"+objectL10n.search+"'>",
        afterInit: function(ms){
            var that = this,
                $selectableSearch = that.$selectableUl.prev(),
                $selectionSearch = that.$selectionUl.prev(),
                selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)',
                selectionSearchString = '#'+that.$container.attr('id')+' .ms-elem-selection.ms-selected';
        
            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
            .on('keydown', function(e){
            if (e.which === 40){
                that.$selectableUl.focus();
                return false;
            }
            });
        
            that.qs2 = $selectionSearch.quicksearch(selectionSearchString)
            .on('keydown', function(e){
            if (e.which == 40){
                that.$selectionUl.focus();
                return false;
            }
            });
        },
        afterSelect: function(){
            this.qs1.cache();
            this.qs2.cache();
        },
        afterDeselect: function(){
            this.qs1.cache();
            this.qs2.cache();
        }
        });

        $('.typerocket-elements-fields-select select').on('change',function(){
            if($(this).val() == 'paypal'){
                $(this).parent().addClass('is-paypal')
            }else{
                $(this).parent().removeClass('is-paypal')
            }
        }).trigger('change')

    //PROFILE IMAGE
    $('#profile-image-form').on('click', '.is-delete, .image-picker-placeholder', function(e) {
        var $form = $(e.delegateTarget);
        if ($(e.currentTarget).is('.is-delete')) {
            $form.find('.image-picker-clear').trigger('click');
        } else if ($(this).find('.croppie-container').length === 0) {
            $form.find('.image-picker-button').trigger('click');
        }
    });
    $('#profile-image-form').on('submit', function(e) {
        e.preventDefault();
        //Send ajax
        var ajaxMethod = $(this).attr('method').toLowerCase();
        $[ajaxMethod]($(this).attr('action'), $(this).serialize()).done(function(data, xhr) {
            //if success replace Image
            var timestamp =  +new Date;
            $('.m-overlay-fullpage').trigger('click');
            $('.typerocket-container .author-picture').attr('style', 'background-image: url("'+data.data.imageUrl+'?'+timestamp+'")');
        }).fail(function(data, xhr) {
            //if error display them
            console.log(data);
        });
    });

    //PROFILE GALLERY
    var currentGalleryTarget = null;
    $('[data-popup=gallery-image], [data-popup=video]').on('click', function(e) {
        e.preventDefault();
        currentGalleryTarget = $(this);
        var $gallery = $(this).parents('.gallery'), data = {image: '', legend: '', credit:'', imgTag: ''}, type  = $(this).data('popup') === 'video' ? 'video' : 'image';
        if (!$gallery.length) {
            $gallery = $(this).parent().next('.gallery');
        }
        var $form = $('#'+$gallery.data('formId'));
        $form.find('h2').hide();
        $form.find('[name="tr[_action]"]').val(type === 'video' ? 'video' : 'gallery_image');
        if ($(this).hasClass('is-modify-image') || $(this).parents('.is-modify-image').length) {
            $form.find('h2[data-popup-action="update"]').show();
            data = $(this).data('form');
            $form.find('.is-delete').show();
            if (type === 'image') {
                data.imgTag = '<img src="'+$(this).data('thumbnail')+'" />';
                $form.find('.button-group').hide();
            } else {
                $form.find('[name="tr[url]"]').attr('readonly');
            }
        } else {
            $form.find('h2[data-popup-action="create"]').show();
            $form.find('.is-delete').hide();
            if (type === 'image') {
                $form.find('.button-group').show();
            } else {
                $form.find('[name="tr[url]"]').removeAttr('readonly');
            }
        }
        
        $form.find('[name="tr[legend]"]').val(data.legend);
        $form.find('[name="tr[credit]"]').val(data.credit);
        if (type === 'image') {
            $form.find('[name="tr[image]"]').val(data.image).nextAll('.image-picker-placeholder').html(data.imgTag);
        } else {
            $form.find('[name="tr[url]"]').val(data.url);
        }
    });
    $('#profile-gallery-form [data-action], #evenement-gallery-form [data-action], #profile-video-form [data-action]').on('click', function(e) {
        $(this).parents('form').find('[name="tr[_action]"]').val($(this).data('action'));
    });
    
    $('#profile-gallery-form, #evenement-gallery-form, #profile-video-form').on('submit', function(e) {
        e.preventDefault();
        //Send ajax
        var ajaxMethod = $(this).attr('method').toLowerCase(), 
        $form = $(this), $gallery = $form.prev(), 
        mode = $form.find('[name="tr[_action]"]').val(),
        type = $form.attr('id') === 'profile-video-form' ? 'video' : 'image';
        if ($form.attr('id') === 'evenement-gallery-form') {
            $gallery = $form.prev().find('.gallery');
        }
        $[ajaxMethod]($(this).attr('action'), $(this).serialize()).done(function(data, xhr) {
            $('.m-overlay-fullpage').trigger('click');
            $form.find('.error, .is-error').remove();

            if (mode === 'delete_gallery_image' || mode === 'delete_video') {
                currentGalleryTarget.remove();
            } else {
                //if success replace Image
                var timestamp =  +new Date;
                if (!currentGalleryTarget || !currentGalleryTarget.hasClass('is-modify-image')) {
                    currentGalleryTarget = $gallery.find('.item-template').clone().removeClass('item-template');
                    $gallery.find('.add').first().before(currentGalleryTarget);
                }
                currentGalleryTarget.attr('style', 'background-image: url("'+data.data.thumbnail+'?'+timestamp+'")');
                currentGalleryTarget.data('form', data.data);
                currentGalleryTarget.data('thumbnail', data.data.thumbnail);
            }

            //Recalculate Add boxes
            var total = $gallery.children('.is-modify-image:visible').length;
            var missing = 3 - (total % 3);
            var $add = $gallery.find('.add').remove().eq(0).clone();
            for (var i = 0; i < missing; i++) {
                $gallery.append($add.clone());
            }

        }).fail(function(xhr) {
            var data = xhr.responseJSON;
            $form.find('h2:visible').after('<div class="m-notice is-error">'+data.message+'</div>');
            //if error display them
            for (var field in data.errors) {
                $form.find('[name="tr['+field+']"]').parents('.control').append('<div class="error"><p>'+data.errors[field][0]+'</p></div>')
            }
        });
    });
}